<template>
    <!-- 案例 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">感谢客户对我们的信任</div>
                <div class="p">用设计满足需求，以策略思维呈现品牌百分百定制开发，一对一的专业设计，全程项目跟踪，集锦用专业和态度为您提供优质的服务</div>
                <div class="moreboxmax">
                    <div class="a a1" @click="kefuclick"><i>在线咨询</i></div> 
                      <div class="a a2" @click="baojia">获取报价</div>
                </div>
            </div>
        </div>
        <div class="caseboxmax caseboxmax3">
            <div class="topmax wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                <div class="h">优秀客户案例</div>
                <div class="p">为客户提供互联网基础建设解决方案，帮助企业实现“互联网+”转型升级。</div>
            </div>
            <div class="toop wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <div class="li" :class="[querInfo.classifyid==''?'cur':'']" @click="getcheck">所有</div>
                <div class="li" v-for="(item,index) in casetit" :key="index" :class="[item.id==querInfo.classifyid?'cur':'']" @click="topclick(item.id)">{{item.title}}</div>
            </div>
            <div class="casemore wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                <div class="li" v-for="(item,index) in caselist" :key="index" @click="caseclick(item.id)">
                   <div class="m"><img :src="item.pic" alt=""></div> 
                    <div class="ter">
                        <div class="h text1">{{item.title}}</div>
                        <!-- <div class="p text2">{{item.brief}}</div> -->
                        <div class="p text2"><i v-for="items in item.tags">{{items}}</i></div>
                    </div>
                </div>
            </div>
            <div class="padeing wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <!-- <div class="li cur">01</div>
                <div class="li">02</div>
                <div class="li">03</div>
                <div class="li prev">上一页</div>
                <div class="li next">下一页</div> -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="querInfo.pageNum"
				:page-size="querInfo.pageSize"
                background
				hide-on-single-page
                layout="prev, pager, next"
                :total="total"></el-pagination>
            </div>
        </div>
        <div class="casebootbox">
            <div class="mk">
                <div class="tit wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="h">部分精选案例，分享创意与智慧</div>
                    <div class="p">不讲故事，只讲事实！用数据说话...</div>
                </div>
                <div class="img">
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/15.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph13.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/14.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph21.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph20.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/12.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph19.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/img1.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph12.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/17.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph18.jpg" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph10.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph15.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph3.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/10.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph16.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph14.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph23.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph9.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph8.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph17.png" alt=""></div>
                    <div class="li wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s"><img src="../assets/img/ph12.png" alt=""></div>
                </div>
            </div>
        </div>
        <!--   -->
        <myfooter></myfooter>
        <!--  -->
        <upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    
    export default {
        data() {
            return {
                parentMessage: 2,
                // 分页
                querInfo: {
                    classifyid: '',
                    pageNum: 1,
                    pageSize: 12
                },
                caselist: [],
                total: 0,
                casetit: [],
                baoMessage: false
            }
        },
        created() {
            this.getCaselist()
        },
        methods: {
            topclick(id){
                this.querInfo.classifyid= id;
                this.getCaselist();
            },
            // 分类
            getcheck(){
                this.querInfo.classifyid= '';
                this.getCaselist();
            },
            // 列表
            async getCaselist(){
                var url = `/api/case/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.post(url)
                
                console.log(res)
                
                if(res.data.code !== 200){
                    return alert('获取案例失败！')
                }
                
                this.caselist = res.data.rows
                this.casetit = res.types
                this.total = res.data.total
                this.id = res.data.rows.id
                
            },
            handleSizeChange(newSize) {
                this.querInfo.pageSize = newSize
                this.getCaselist()
            },
            handleCurrentChange(newPage) {
                this.querInfo.pageNum = newPage
                this.getCaselist()
            },
            caseclick(id){
                /* var url = `/casedata?id=${id}&title=${title}&brief=${brief}` */
                var url = `/casedata?id=${id}`
                const newWindowUrl = this.$router.resolve(url).href
                window.open(newWindowUrl, '_blank')
            },
            handleUpdate(updatedValue) {
                this.baoMessage = updatedValue; // 更新父组件的Prop值
            },
            baojia() {
                this.baoMessage = true;
            },
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            }
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>

</style>